import { BehaviorSubject } from 'rxjs';

import jsonStorage from '../utils/json-storage';

const addressCoordinates = new BehaviorSubject({});
const isModalSubject = new BehaviorSubject(false);

export const IsAddressRegistered = {
  subject: undefined,

  lazyInit() {
    if (IsAddressRegistered.subject) return IsAddressRegistered.subject;

    const storage = window.localStorage;
    const isRegistered = jsonStorage.get('IsAddressRegistered', { storage });

    IsAddressRegistered.subject = new BehaviorSubject(isRegistered);
    return IsAddressRegistered.subject;
  },

  update: mode => {
    const isRegistered = IsAddressRegistered.lazyInit();
    isRegistered.next(mode);
    const storage = window.localStorage;
    jsonStorage.set('IsAddressRegistered', mode, { storage });
  },

  delete: () => {
    const storage = window.localStorage;
    jsonStorage.remove('IsAddressRegistered', { storage });
  },

  subscribe: setState => {
    const isRegistered = IsAddressRegistered.lazyInit();
    return isRegistered.subscribe(setState);
  },
};

export const PostalCode = {
  subject: undefined,

  lazyInit() {
    if (PostalCode.subject) return PostalCode.subject;

    const storage = window.localStorage;
    const _postalCode = jsonStorage.get('PostalCode', { storage }) || undefined;
    const postalCode = !_postalCode || ['undefined', 'null', ''].includes(_postalCode) ? undefined : _postalCode;

    PostalCode.subject = new BehaviorSubject(postalCode);
    return PostalCode.subject;
  },

  update: _postal => {
    const postalCode = PostalCode.lazyInit();
    postalCode.next(_postal);
    const storage = window.localStorage;
    jsonStorage.set('PostalCode', _postal, { storage });
  },
  delete: () => {
    const storage = window.localStorage;
    jsonStorage.remove('PostalCode', { storage });
  },
  subscribe: setState => {
    const postalCode = PostalCode.lazyInit();
    return postalCode.subscribe(setState);
  },
  getValue: () => {
    const postalCode = PostalCode.lazyInit();
    return postalCode.value;
  },
};

export const AddressCoordinates = {
  update: coordinates => {
    addressCoordinates.next(coordinates);
  },
  subscribe: setState => addressCoordinates.subscribe(setState),
};

export const IsCheckAddressModal = {
  update: value => {
    isModalSubject.next(value);
  },
  subscribe: setState => isModalSubject.subscribe(setState),
};

export const SelectedShopId = {
  subject: undefined,

  lazyInit() {
    if (SelectedShopId.subject) return SelectedShopId.subject;

    const storage = window.localStorage;
    const _selectedShopId = jsonStorage.get('SelectedShopId', { storage });
    const selectedShopId =
      !_selectedShopId || ['undefined', 'null', ''].includes(_selectedShopId) ? undefined : _selectedShopId;

    SelectedShopId.subject = new BehaviorSubject(selectedShopId);
    return SelectedShopId.subject;
  },

  update: _shopId => {
    const selectedShopId = SelectedShopId.lazyInit();
    // const shopId = parseInt(_shopId);
    selectedShopId.next(_shopId);
    const storage = window.localStorage;
    jsonStorage.set('SelectedShopId', _shopId, { storage });
  },
  delete: () => {
    const storage = window.localStorage;
    jsonStorage.remove('SelectedShopId', { storage });
  },
  subscribe: setState => {
    const selectedShopId = SelectedShopId.lazyInit();
    return selectedShopId.subscribe(setState);
  },
  getValue: () => {
    const selectedShopId = SelectedShopId.lazyInit();
    return selectedShopId.value;
  },
};

export default {
  IsAddressRegistered,
  PostalCode,
  AddressCoordinates,
  IsCheckAddressModal,
  SelectedShopId,
};
